import axios from "axios";
import { API_CONFIG, API_ENDPOINTS} from "./config"

const api = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: API_CONFIG.HEADERS,
});

// --- REGISTER ---
export const registerUser = async (payload) => {
  const res = await api.post(API_ENDPOINTS.AUTH.REGISTER, payload);
  return res.data;
};

// --- LOGIN ---
export const loginUser = async (payload) => {
  const res = await api.post(API_ENDPOINTS.AUTH.LOGIN, payload);
  return res.data; // Expect token + user
};

// --- VERIFY EMAIL ---
export const verifyEmail = async (token) => {
  const res = await api.post(API_ENDPOINTS.AUTH.VERIFY_EMAIL, { token });
  return res.data;
};

export const forgotpasswordcrew = async (payload) => {
  const res = await api.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD_CREW, payload);
  return res.data;
};

export const resetpassword = async (payload) => {
  const res = await api.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, payload);
  return res.data;
};


export const signUpStep1 = async (payload) => {
  const res = await api.post(API_ENDPOINTS.AUTH.SIGN_UP_1, payload);
  return res.data;
};

export const signUpStep2 = async (payload) => {
  const res = await api.post(API_ENDPOINTS.AUTH.SIGN_UP_2, payload);
  return res.data;
};

export const signUpStep3 = async (payload) => {
  const res = await api.post(API_ENDPOINTS.AUTH.SIGN_UP_3, payload);
  return res.data;
};
